export const MANAGE_USERS_SITE_SECTION = 'users';

// -------- User list
export const PAGE_USER_LIST_DISPLAYED = 'user_list_displayed';
export const USER_LIST = 'user list';
export const CLICK_DELETE_USER = 'remove_user_pressed';
export const CLICK_DELETE_USER_CONFIRMATION_YES = 'remove_user_confirm_pressed';
export const CLICK_DELETE_USER_CONFIRMATION_NO =
  'delete-user-confirmation-no-interacted';
export const ALERT_VIEWED = 'alert_viewed';

// -------- Edit user
export const PAGE_EDIT_USER_DISPLAYED = 'edit_user_displayed';
export const CURRENT_PAGE_EDIT_USER = 'edit user';
export const CLICK_SEND_PASSWORD_RESET_LINK = 'send_password_reset_pressed';
export const CLICK_RESEND_REGISTRATION_LINK = 'resend_activation_email_pressed';
export const CLICK_UPDATE_USER = 'edit_user_save_pressed';
export const CLICK_EDIT_USER_CANCEL = 'edit_user_cancel_pressed';
export const EDIT_USER_SAVE_SUCCESS = 'edit_user_save_succeeded';

// -------- Add user step 1
export const PAGE_USER_EMAIL_DISPLAYED = 'add_user_email_displayed';
export const ADD_USER_EMAIL = 'add user email';
export const CLICK_ADD_USER_STEP1_CANCEL = 'add_user_cancel_pressed';

// -------- Add user step 2
export const PAGE_USER_DETAILS_DISPLAYED = 'add_user_details_displayed';
export const ADD_USER_DETAILS = 'add user details';
export const CLICK_ADD_USER_STEP2_SUBMIT = 'add_user_submit_pressed';
export const CLICK_ADD_USER_SUBMIT_SUCCESS = 'add_user_succceeded';
export const CLICK_ADD_USER_STEP2_CANCEL = 'add_user_cancel_pressed';
